<template>
  <div>    

    <h5>Benefits</h5>
    <p v-if="futureCurrentDurationDiff">
      <i class="icon-icon-clock-blue"></i>
      <span v-html="futureCurrentDurationDiff"></span>
    </p>
  
  </div>
</template>

<script>
import utils from '../helpers/utils';

import mixinFilters from '../mixins/filters'

export default {
  name: 'trip-planner-future-benefits',
  props: ['routeIndex'],
  mixins: [mixinFilters],
  data () {
    return {
    }
  },
  computed: {
    futureRoutes () {      
      if (!this.$store.getters['tripPlanner/futureTripData'].plan) {
        return false
      }
      return this.$store.getters['tripPlanner/futureTripData'].plan.itineraries;
    },           
    futureRoute () {
      if (!this.futureRoutes) {
        return false
      }
      if (!this.futureRoutes[this.routeIndex]) {
        return false        
      }
      return this.futureRoutes[this.routeIndex]
    },    
    currentRoutes () {      
      if (!this.$store.getters['tripPlanner/currentTripData'].plan) {
        return false
      }
      return this.$store.getters['tripPlanner/currentTripData'].plan.itineraries;
    },           
    currentRoute () {
      if (!this.currentRoutes) {
        return false
      }
      if (!this.currentRoutes[this.routeIndex]) {
        return false        
      }
      return this.currentRoutes[this.routeIndex]
    },    

    futureCurrentDurationDiff () {
      if (!this.futureRoute || !this.currentRoute) {
        return false
      }
      let timeDiff = this.currentRoute.duration - this.futureRoute.duration
      let timeDiffFormatted = utils.formatDuration(timeDiff)
      let result = 'Trip will be ' + timeDiffFormatted + ' quicker.'
      if (timeDiff <= 60) {
        result = 'No difference in trip duration.'
      }
      return result
    },
    router () { // get router params and query
      return this.$store.getters['tripPlanner/router'];
    },     
  },
  watch: {
  },  
  methods: { 
  },
  mounted () {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.icon-icon-clock-blue {
  margin-right: 10px;  
}
</style>



// WEBPACK FOOTER //
// src/components/TripPlannerFutureBenefits.vue